<template>
  <div id="page" class="v-application v-application--is-ltr theme--light">
    <div class="app-content" :class="{show: show}">
      <div class="v-application--wrap">
        <main class="v-main" data-booted="true">
          <div class="v-main__wrap">
            <div class="home fill-height d-flex flex-column flex-scroll-y">
              <img src="@/assets/images/banner-1.png" class="banner">
              <img src="@/assets/images/order-help.png" class="order-help">
              <div class="near-shop">
                <div class="d-flex align-end">
                  <div class="sb-title d-flex align-center">
                    <div class="title-line flex-shrink-0" style="background-color: rgb(255, 255, 255);"></div>
                    <div class="title-text" style="color: rgb(255, 255, 255);">附近门店</div>
                  </div>
                  <div class="spacer"></div>
                  <div class="near-desc">根据您所在的位置，为您推荐最近的门店</div>
                </div>
                <div class="selected-shop">
                  <div class="loading-shop-list d-flex flex-column align-center justify-center">
                    <template v-if="!storeList.length">
                      <template v-if="!latlngErr">
                        <div role="progressbar" aria-valuemin="0" aria-valuemax="100" class="v-progress-circular loader v-progress-circular--indeterminate" style="height: 32px; width: 32px; color: rgb(22, 107, 78); caret-color: rgb(22, 107, 78);">
                          <svg xmlns="http://www.w3.org/2000/svg" viewBox="22.857142857142858 22.857142857142858 45.714285714285715 45.714285714285715"><circle fill="transparent" cx="45.714285714285715" cy="45.714285714285715" r="20" stroke-width="5.714285714285714" stroke-dasharray="125.664" stroke-dashoffset="125.66370614359172px" class="v-progress-circular__overlay"></circle></svg>
                        </div>
                        <div v-if="latlngIng">正在定位</div>
                        <div v-else>正在获取附近门店</div>
                      </template>
                      <div v-else>获取位置信息出错，请开启手机定位功能并允许应用获取</div>
                    </template>
                    <template v-else>
                      <div class="shop-card">
                        <div class="d-flex align-center">
                          <div class="shop-name">
                            <span class="name">星巴克{{store._name}}</span>
                            <span class="tag">自提</span>
                            <span class="tag yellow" v-if="+store.mtzt">配送</span>
                          </div>
                          <div class="shop-distance d-flex align-center">
                            <img src="@/assets/images/pin.png" class="pin">
                            <div v-if="+store.distance > 1000">{{ ((+store.distance) / 1000).toFixed(2)}}km</div>
                            <div v-else>{{store.distance}}m</div>
                          </div>
                        </div>
                        <div class="shop-address d-flex align-center">
                          <div class="shop-address-detail">{{store.address}}</div>
                          <div class="spacer"></div>
                          <div class="select-shop-btn pill-button-outline flex-shrink-0" @click="onChangeShop">切换门店</div>
                        </div>
                      </div>
                    </template>
                  </div>
                </div>
              </div>
              <div class="go-to-order-btn d-flex align-center justify-center" @click="onStart">
                <div v-if="!isEnter" role="progressbar" aria-valuemin="0" aria-valuemax="100" class="v-progress-circular loader v-progress-circular--indeterminate" style="height: 14px; width: 14px; color: #fff; caret-color: #fff">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="22.857142857142858 22.857142857142858 45.714285714285715 45.714285714285715"><circle fill="transparent" cx="45.714285714285715" cy="45.714285714285715" r="20" stroke-width="5.714285714285714" stroke-dasharray="125.664" stroke-dashoffset="125.66370614359172px" class="v-progress-circular__overlay"></circle></svg>
                </div>
                <span>开始点饮品</span>
              </div>
              <div class="spacer"></div>
              <div class="hint">
                <div class="d-flex align-center">
                  <div class="hint-title-line flex-grow-1"></div>
                  <div class="hint-title flex-shrink-0">温馨提示</div>
                  <div class="hint-title-line flex-grow-1"></div>
                </div>
                <div class="hint-content d-flex justify-center"> 到店前10-15分钟在线点饮品，到店直接在“取餐台”领取即可</div>
              </div>
              <img src="@/assets/images/order-btn.png" class="my-order-btn" @click="onOrders">
              <img v-if="timeActivity && timeActivity.share_enabled" src="@/assets/images/order-btn2.png" class="my-order-btn my-order-btn2" @click="onGoActivity">
              <div role="dialog" class="v-dialog__container shop-closed-dialog-frame"><!----></div>
            </div>
          </div>
        </main>
        <footer>
          <div class="v-snack v-snack--bottom v-snack--has-background">
            <div class="v-snack__wrapper v-sheet theme--dark" v-if="latlngErr">
              <div role="status" aria-live="polite" class="v-snack__content">获取位置信息出错</div>
              <div class="v-snack__action "></div>
            </div>
          </div>
          <div class="simple-dialog-frame">
            <div role="dialog" class="v-dialog__container simple-dialog loader"></div>
          </div>
        </footer>
      </div>
      <transition name="fade">
        <div v-if="showClosedDialog">
          <div class="weui-mask"></div>
          <div class="weui-dialog weui-closed-dialog">
            <div class="shop-closed-dialog d-flex flex-column align-center v-sheet theme--light">
              <img src="@/assets/images/shop-closed.png" class="closed-image">
              <div class="closed-title">店铺休息中</div>
              <div class="closed-desc d-flex flex-column align-center">
                <div> 店铺打烊啦，请在营业时间点餐哦。 </div>
                <div> 营业时间：08:00-21:00 </div>
              </div>
              <div class="closed-close d-flex align-center justify-center" @click="showClosedDialog = false">好的，知道了</div>
            </div>
          </div>
        </div>
      </transition>
      <transition name="fade">
        <div v-if="showActivityDialog">
          <div class="weui-mask"></div>
          <div class="weui-dialog weui-closed-dialog">
            <div class="shop-closed-dialog shop-activity-dialog d-flex flex-column align-center v-sheet theme--light">
              <img src="@/assets/images/shop-activity.png" class="closed-image">
              <div class="closed-title">{{timeActivity.name}}</div>
              <div class="closed-desc d-flex flex-column align-center">
                <div v-if="timeActivity.sale_enabled"> 1. 限时享受<b>{{timeActivity.sale_amount}}</b>笔订单<b>{{ timeActivity.sale_discount }}</b>折优惠 </div>
                <template v-if="timeActivity.share_enabled">
                  <div> {{timeActivity.sale_enabled ? 2 : 1}}. 邀請好友享受全月<b>最高{{ timeActivity.share_discount3 || timeActivity.share_discount2 || timeActivity.share_discount1 }}折优惠</b> </div>
                  <div> {{timeActivity.sale_enabled ? 3 : 2}}. 活动时间：{{moment(timeActivity.start_date).format('MM-DD')}} ~ {{moment(timeActivity.end_date).format('MM-DD')}} </div>
                </template>
              </div>
              <div class="d-flex">
                <div class="closed-close d-flex align-center justify-center" style="margin-right: 0.175rem" @click="showActivityDialog = false">好的</div>
                <div class="closed-close closed-invite d-flex align-center justify-center" style="margin-left: 0.175rem" @click="onGoActivity">邀請好友</div>
              </div>
            </div>
          </div>
        </div>
      </transition>
      <transition name="fade">
        <div v-if="showToast">
          <div class="weui-mask_transparent"></div>
          <div class="weui-toast weui-toast_text">
            <p class="weui-toast__content">{{ toastMsg }}</p>
          </div>
        </div>
      </transition>
    </div>
    <transition name="fade">
      <div v-if="showLoading">
        <div class="weui-mask_transparent"></div>
        <div class="weui-toast">
          <span class="weui-primary-loading weui-icon_toast">
            <span class="weui-primary-loading__dot"></span>
          </span>
          <p class="weui-toast__content">加载中...</p>
        </div>
      </div>
    </transition>
  </div>
</template>

<style lang="less" scoped>
@import "../mixins";

#page {
  min-height: 100vh;
  background-color: #fff;
}

.app-content {
  opacity: 0;
  transition: opacity 0.2s ease;
  background-color: #fff;
}

.app-content.show {
  opacity: 1;
}

.fade-enter {
  opacity: 0;
}

.fade-enter-active {
  transition: opacity 0.2s;
}

.sb-title {
  font-size: .32rem
}

.sb-title .title-line {
  width: .06rem;
  height: .3rem;
  border-radius: .03rem
}

.sb-title .title-text {
  margin-left: .14rem;
  font-weight: 900
}

.shop-card .shop-name {
  min-width: 0;
  display: flex;
  align-items: center;
  flex: 1;
  .name {
    font-size: 15px;
    font-weight: 700;
    margin-right: 6px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .tag {
    font-size: 10px;
    color: #fff;
    background: #166b4e;
    padding: 0 2.5px;
    border-radius: 2.5px;
    font-weight: 500;
    margin-right: 5px;
    white-space: nowrap;
    &:last-child {
      margin-right: 0;
    }
    &.yellow {
      background-color: #ffd640;
      color: #333;
    }
  }
}

.shop-card .shop-distance {
  font-size: .24rem;
  color: #166b4e
}

.shop-card .shop-distance .pin {
  display: block;
  width: .24rem;
  height: .28rem;
  margin-left: .2rem;
  margin-right: .08rem
}

.shop-card .shop-address {
  margin-top: .20rem
}

.shop-card .shop-address .shop-address-detail {
  min-width: 0;
  font-size: .24rem;
  color: #999
}

.shop-card .shop-address .select-shop-btn {
  margin-left: .6rem
}

.shop-closed-dialog {
  padding-bottom: .6rem;
  border-radius: .3rem;
  overflow: hidden
}

.shop-closed-dialog .closed-image {
  display: block;
  width: 6rem;
  height: 3.24rem
}

.shop-closed-dialog .closed-title {
  margin-top: .5rem;
  font-size: .4rem;
  font-weight: 900
}

.shop-closed-dialog .closed-desc {
  margin-top: .36rem;
  font-size: .24rem;
  color: #999
}

.shop-closed-dialog .closed-close {
  margin-top: .4rem;
  width: 3rem;
  height: .7rem;
  border-radius: .35rem;
  background-image: linear-gradient(90deg, #af9153, #d5ba74);
  font-size: .3rem;
  color: #fff
}

.shop-activity-dialog {
  .closed-title {
    margin-top: .35rem;
  }
  .closed-desc {
    margin-top: .1rem;
    width: 4.5rem;
    font-size: 13px;
    color: #333;
    align-items: flex-start !important;
  }
  .closed-close {
    width: 2.25rem;
    background-image: linear-gradient(90deg, #949494, #bfbfbf);
    &.closed-invite {
      background-image: linear-gradient(90deg, #166b4e, #28ca93);
    }
  }
}

.home {
  position: relative;
  padding: .3rem;
  background-color: #166b4e;
  box-sizing: border-box;
}

.home .banner {
  display: block;
  width: 6.9rem;
  height: 2.4rem;
}

.home .order-help {
  display: block;
  width: 6.9rem;
  height: 2.53rem;
  margin-top: .4rem
}

.home .near-shop {
  margin-top: .4rem
}

.home .near-shop .near-desc {
  font-size: .22rem;
  color: hsla(0, 0%, 100%, .5)
}

.home .near-shop .selected-shop {
  margin-top: .3rem;
  padding: .4rem .3rem;
  border-radius: .1rem;
  background-color: #fff
}

.home .near-shop .selected-shop .loading-shop-list {
  font-size: .24rem
}

.home .near-shop .selected-shop .loading-shop-list .loader {
  margin-bottom: .2rem
}

.home .go-to-order-btn {
  margin-top: .4rem;
  width: 6.9rem;
  height: .9rem;
  border-radius: .45rem;
  font-size: .3rem;
  font-weight: 700;
  color: #fff;
  background-image: linear-gradient(90deg, #af9153, #d5ba74);
  text-decoration: none;
  display: flex;
  flex-direction: row;
  align-items: center;
  span {
    padding: 0 .125rem;
  }
}

.home .hint {
  margin-top: .6rem;
  font-size: .24rem;
  color: #093526
}

.home .hint .hint-title-line {
  height: 1px;
  background-color: rgba(9, 53, 38, .2)
}

.home .hint .hint-title {
  margin: 0 .2rem;
  font-size: .28rem
}

.home .hint .hint-content {
  margin-top: .24rem
}

.home .my-order-btn {
  display: block;
  width: 1.87rem;
  height: .75rem;
  position: fixed;
  top: .35rem;
  right: 0;
  &.my-order-btn2 {
    top: 1.15rem;
  }
}

.weui-closed-dialog {
  width: 298px;
  max-width: none;
  border-radius: 18px;
}

</style>

<script>
import request from "../utils/request";
import gfRequest from "../utils/gfRequest";
import moment from 'moment';

export default {
  data() {
    return {
      show: false,
      showLoading: false,
      showClosedDialog: false,
      showActivityDialog: false,
      showToast: false,
      checkAppKey: false,
      isEnter: false,
      isShopClosed: false,
      isWxBind: false,
      isWxPay: false,
      isAliPay: false,
      memberId: null,
      pageReminder: '',
      latlngIng: true,
      latlngErr: false,
      storeList: [],
      timeActivity: null,
    };
  },
  computed: {
    userInfo() {
      return this.$store.state.global.userInfo
    },
    appEnv() {
      return this.$store.state.global.appEnv
    },
    store() {
      return this.$store.state.global.store
    }
  },
  created() {
    const hour = moment().hour()
    if (hour < 8 || hour > 21) {
      this.showClosedDialog = true;
      this.isShopClosed = true;
    }
    if (!this.appEnv.prod) {
      const appEnv = {
        prod: this.appEnv.prod,
        appId: 'CC202104110012172897',
        appKey: 'EDF0763043A073BC',
        platformId: 15,
      }
      const userInfo = {
        id: 122551,
        invite_code: "120897",
        avatar: "http://thirdwx.qlogo.cn/mmopen/vi_32/Q0j4TwGTfTLD9jWrnw4j9YFHIKiaE71Pka0Bnz2t8vjcQGax1YibKPLehSjhfqd0uibFziaC1unYb5O80OUI7VDGsQ/132",
        nickname: "文贤",
        mobile: '18958906820',
        latitude: "27.921809",
        longitude: "120.811979",
        wechat_unionid: '',
        // wx_openid: '',
        wx_openid: 'ozbMf5yw9AnKfs00RWxA9LzlSBHU',
      };
      this.$store.dispatch('global/commitAppEnv', appEnv)
      this.$store.dispatch('global/commitUserInfo', userInfo)
      new VConsole();
    }
  },
  mounted() {
    const prod = this.appEnv.prod;
    const appEnv = prod ? Object.assign({}, this.appEnv, {appKey: ''}) : this.appEnv;
    const appId = this.$route.query.appid ||'';
    const platformId = this.$route.query.platformid || '';
    const h5Position = this.$route.query.h5Position || '';
    if (appId) appEnv.appId = appId;
    if (platformId) appEnv.platformId = parseInt(platformId, 10) || 0;
    if (!appEnv.appId || !appEnv.platformId) {
      this.show = true;
      this.latlngErr = true;
      this.toast('商家存在未配置的参数请联系客服');
      return;
    }
    this.$store.dispatch('global/commitAppEnv', appEnv);
    const mounted = () => {
      const h5Userinfo = getH5UserInfo();
      if (h5Userinfo) {
        new Promise(async () => {
          await h5Userinfo.then((resp) => {
            const userInfo = JSON.parse(resp);
            console.log('userinfo', userInfo, resp);
            userInfo.latitude = this.userInfo.latitude;
            userInfo.longitude = this.userInfo.longitude;
            this.isWxBind = !!+userInfo.wx_bind;
            this.$store.dispatch('global/commitUserInfo', userInfo)
          }).catch((err) => {
            if (typeof err === 'object') {
              this.toast('未能获取到用户信息请联系客服: ' + JSON.parse(err));
            } else if (typeof err === 'string') {
              this.toast('未能获取到用户信息请联系客服: ' + err);
            }
          });
          let appKey = '';
          await checkAppInfo().then(version => {
            appKey = version;
          }).catch((err) => {});
          await this.getTenantCfg(appKey).catch((err) => {});
          await this.appMemberLink().catch(err => {});
          this.latlngIng = false;
          Promise.all([this.queryStore(), this.queryActivity()]).then(() => {
            this.isEnter = true
          }).catch(err => {})
        })
      } else {
        if (!this.appEnv.prod) {
          new Promise(async () => {
            await this.getTenantCfg(this.appEnv.appKey).catch((err) => {});
            await this.appMemberLink().catch(err => {});
            setTimeout(() => {
              this.latlngIng = false;
              setTimeout(() => {
                Promise.all([this.queryStore(), this.queryActivity()]).then(() => {
                  this.isEnter = true
                }).catch(err => {})
              }, 150)
            }, 150)

          })
        } else {
          this.show = true;
          this.toast('未能获取到用户信息请联系客服');
        }
      }
    }

    new Promise(async () => {
      if (this.appEnv.prod) {
        this.show = true;
        if (h5Position) {
          navigator.geolocation.getCurrentPosition((position) => {
            const userInfo = this.userInfo;
            userInfo.latitude = position.coords.latitude;
            userInfo.longitude = position.coords.longitude;
            this.$store.dispatch('global/commitUserInfo', userInfo)
            mounted();
          }, () => {
            this.latlngIng = false;
            this.latlngErr = true;
          });
        } else {
          let isPosition = false
          getLocation().then((resp) => {
            console.log('position', resp);
            const {lat, lon, city, address} = resp;
            const userInfo = this.userInfo;
            if (!lat || !lon) {
              navigator.geolocation.getCurrentPosition((position) => {
                userInfo.latitude = position.coords.latitude;
                userInfo.longitude = position.coords.longitude;
                this.$store.dispatch('global/commitUserInfo', userInfo)
                mounted();
              }, () => {
                this.latlngIng = false;
                this.latlngErr = true;
              });
              return
            }
            userInfo.latitude = lat;
            userInfo.longitude = lon;
            isPosition = true
            this.$store.dispatch('global/commitUserInfo', userInfo)
            mounted();
          }).catch((err) => {
            this.latlngIng = false;
            this.latlngErr = true;
          })
          setTimeout(() => {
            if (!isPosition) {
              navigator.geolocation.getCurrentPosition((position) => {
                const userInfo = this.userInfo;
                userInfo.latitude = position.coords.latitude;
                userInfo.longitude = position.coords.longitude;
                this.$store.dispatch('global/commitUserInfo', userInfo)
                mounted();
              }, (err) => {
                this.latlngIng = false;
                this.latlngErr = true;
              });
            }
          }, 1000)
        }
      } else {
        this.show = true;
        mounted();
      }
    })

  },
  methods: {
    moment,
    isHuaJuanY() {
      const ua = window.navigator.userAgent.toLowerCase();
      return ua.indexOf('huajuanyun') !== -1 || ua.indexOf('html5plus') !== -1 || this.userInfo.id;
    },
    toast(v, write = true) {
      this.toastMsg = v;
      if (this.isHuaJuanY()) {
        showToast(v);
      } else {
        this.showToast = true;
        setTimeout(() => {
          this.showToast = false;
        }, 2000)
      }
      if (write) {
        request({
          url: `/open/api/analysis/log`,
          method: 'POST',
          data: {
            uid: this.userInfo.id,
            appid: this.appEnv.appId,
            appkey: this.appEnv.appKey,
            platformId: this.appEnv.platformId,
            nickname: this.userInfo.nickname,
            msg: v
          },
        }).then().catch(err => {
        })
      }
    },
    queryStore() {
      const newRequest = gfRequest({
        url: `/api/starbucks/store`,
        method: 'GET',
        params: {latitude: this.userInfo.latitude, longitude: this.userInfo.longitude}
      });
      newRequest.then((resp) => {
        this.storeList = resp.data.map(t => {
          t._name = t.name.replace('星巴克（', '').replace('）', '')
          return t
        });
        if (this.storeList && this.storeList.length) {
          const store = this.storeList[0]
          this.$store.dispatch('global/commitStore', store);
        }
      })
      return newRequest;
    },
    queryActivity() {
      const newRequest = request({
        url: `/open/api/time/activity`,
        method: 'GET',
        params: {appid: this.appEnv.appId, appkey: this.appEnv.appKey, platformId: this.appEnv.platformId, openid: this.userInfo.wx_openid, unionid: this.userInfo.wechat_unionid}
      });
      newRequest.then((resp) => {
        if (resp.list && resp.list.length) {
          const noJoin = resp.list.filter(t => !t.is_join);
          this.timeActivity = noJoin.length ? noJoin[0] : resp.list[0];
          if (!this.timeActivity.is_join && this.timeActivity.share_enabled) {
            this.showActivityDialog = true;
          }
          this.$store.dispatch('global/commitActivity', this.timeActivity)
        }
      })
      return newRequest;
    },
    getTenantCfg(version) {
      const newRequest = request({
        url: `/open/api/account/config`,
        method: 'GET',
        params: {appid: this.appEnv.appId, platformId: this.appEnv.platformId, appkey: version}
      });
      newRequest.then((resp) => {
        const {expiry_at, appkey, wxpay, alipay, page_reminder } = resp;
        const appEnv = this.appEnv
        appEnv.appKey = version;
        this.isWxPay = wxpay;
        this.isAliPay = alipay;
        this.checkAppKey = appkey === version;
        this.pageReminder = page_reminder.split(/[\n\r]/g);
        const expiryAt = moment(expiry_at, 'YYYY-MM-DD HH:mm');
        const nowAt = moment(new Date());
        if (nowAt.isAfter(expiryAt)) {
          this.isExpiryAtOut = true;
          this.toast('服务存在异常，错误码：10001');
        }
        this.$store.dispatch('global/commitAppEnv', appEnv);
        this.$store.dispatch('global/commitWxPay', wxpay);
        this.$store.dispatch('global/commitAliPay', alipay);
      }).catch((error) => {
        if (error.response && error.response.data) {
          this.toast(error.response.data.msg);
        }
      });
      return newRequest;
    },
    onChangeShop() {
      if (!this.checkAppKey) {
        this.toast('商户关联平台不一致请联系客服: ' + this.appEnv.appKey);
        return;
      }
      this.$router.push({
        path: '/shops',
      });
    },
    appMemberLink() {
      const newRequest = request({
        url: `/open/api/member/link`,
        method: 'POST',
        data: {
          appid: this.appEnv.appId,
          platformId: this.appEnv.platformId,
          appkey: this.appEnv.appKey,
          uid: this.userInfo.id,
          nickname: this.userInfo.nickname,
          avatar: this.userInfo.avatar,
          invite_code: this.userInfo.invite_code
        }
      });
      newRequest.then((resp) => {
        this.memberId = resp.id;
      }).catch((error) => {
        if (error.response && error.response.data) {
          this.toast(error.response.data.msg);
        }
      })
      return newRequest;
    },
    onIssue() {
      openLinkByAlias('customerService');
    },
    onOrders() {
      if (!this.userInfo.id) {
        this.toast('未能获取到用户信息请联系客服: ');
      } else {
        this.$router.push({
          path: '/orders',
        });
      }
    },
    onGoActivity() {
      this.showActivityDialog = false;
      if (!this.isWxBind) {
        this.toast('请先绑定微信账户哦');
        return
      }
      this.$router.push({path: 'invite'});
    },
    onStart() {
      if (!this.isEnter) {
        return;
      }
      if (this.isShopClosed) {
        this.toast('店铺打烊啦，请在营业时间点餐哦。', false);
        return
      }
      if (this.isExpiryAtOut) {
        this.toast('服务存在异常，错误码：10001');
        return;
      }
      if (this.latlngErr) {
        this.toast('获取位置出错');
        return
      }
      if (!this.store || !this.store.id) {
        const store = this.storeList[0]
        if (store) {
          this.$store.dispatch('global/commitStore', store);
        } else {
          this.toast('请先选择门店');
          return;
        }
      }
      this.$router.push({
        path: '/menus'
      })
    }
  }
}
</script>
